import React from "react";

const Logout = ({ handleLogout, userName }) => {
    const logoutStyle = {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        right: "50px",
        position: "absolute",
        marginTop: "10px",
        background: "rgba(248,248,248,0.8)",
        zIndex: 100,
        boxShadow: "0 0 0 2px rgba(0, 0, 0, .1)",
        borderRadius: "4px",
        height: "29px",
    }
    return (
    <div style={logoutStyle}>
        <div style={{ paddingLeft: "8px" }}>{userName}</div>
        <button type="button" className="btn btn-link" style={{ fontSize: "0.8em", padding: "0.2em 0.5em" }} onClick={handleLogout}>Logout</button>
    </div>
    );
}

export default Logout;